export default __webpack_public_path__ + "static/media/news36.a173d669.jpg";